import { render, staticRenderFns } from "./HistoriaH.vue?vue&type=template&id=a9d6324e"
import script from "./HistoriaH.vue?vue&type=script&lang=js"
export * from "./HistoriaH.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports